import React from "react";
import { Button } from "@/components/ui/button";
import { CalendarDays } from "lucide-react";

const EventsSection = () => {
  return (
    <section className="py-0">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-start gap-4">
          <h2 className="text-3xl font-bold tracking-tight">Events</h2>
          <p className="text-muted-foreground text-lg">
            Join us at our upcoming events to learn more about fine-tuning and
            RL, network with other AI engineers and researchers, and stay
            updated on the latest developments in the field.
          </p>

          <Button
            asChild
            external
            variant="outline"
            size="lg"
            className="mt-4 bg-background/80 dark:bg-background/20 outline-button-hover"
          >
            <a href="https://lu.ma/openpipe">
              <CalendarDays className="mr-2" />
              View Upcoming Events
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
